<template>
  <div style="width: 100%; height: 50px">
    <div style="width: 1200px; margin: 0 auto">
      <span class="breadcrumb">当前位置：</span>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item v-for="(item, i) in titles" :key="i" :to="{ path: item.path }">{{ item.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CurrentLocal',
  props: {
    titles: {
      type: Array,
      require: true
    }
  }
}
</script>

<style scoped>
  .breadcrumb {
    line-height: 50px;
    float: left;
    font-size: 16px;
  }
</style>
